import { render, staticRenderFns } from "./marketKpiList.vue?vue&type=template&id=f90bb524&scoped=true"
import script from "./marketKpiList.vue?vue&type=script&lang=js"
export * from "./marketKpiList.vue?vue&type=script&lang=js"
import style0 from "./marketKpiList.vue?vue&type=style&index=0&id=f90bb524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90bb524",
  null
  
)

export default component.exports